declare global {
  interface File {
    getExtension(): string | undefined;
    humanReadableSize(si?: boolean, dp?: number): string;
  }
}

File.prototype.getExtension = function () {
  return this?.name.split('.').pop();
};

File.prototype.humanReadableSize = function (si = false, dp = 1) {
  const bytes = this.size;
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }

  const units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  let u = -1;
  const r = 10 ** dp;

  let size = bytes;
  do {
    size /= thresh;
    ++u;
  } while (Math.round(Math.abs(size) * r) / r >= thresh && u < units.length - 1);

  return size.toFixed(dp) + ' ' + units[u];
};

export { };
